import Telephone from "../assets/svgs/telephone";
import WhatsApp from "../assets/svgs/whatSapp";

export const ActionsBtn = () => {
    const whatsAppInitialText = 'היי, אשמח להזמין...';
    return <section className="actions-btn flex space-between">
        <a target="_blanc" href={`https://wa.me/9720528011016?text=${encodeURI(whatsAppInitialText)}`} className="whats-aap">
            <WhatsApp /> 
        </a>
        <a target="_blanc" href="tel:9750528011016" className="telephone">
            <Telephone />
        </a>
    </section>;
};